import {
  GetInfringementsQueryVariables,
  InfringementSummaryFilter,
  GetInfringementCandidatesQueryVariables,
  InfringementCandidateSummaryFilter,
} from 'src/app/gql/__generated__/hooks';

// Action types
export enum InfringementTableDataActionType {
  UPDATE_FILTER = 'UPDATE_FILTER',
  UPDATE_BOOLEAN_FILTER = 'UPDATE_BOOLEAN_FILTER',
  UPDATE_TIME_RANGE_FILTER = 'UPDATE_TIME_RANGE_FILTER',
  UPDATE_TAG_FILTER = 'UPDATE_TAG_FILTER',
  CLEAR_FILTER = 'CLEAR_FILTER',
  CLEAR_FILTERS = 'CLEAR_FILTERS',
  TOGGLE_CANDIDATES = 'TOGGLE_CANDIDATES',
  SORT_TABLE = 'SORT_TABLE',
}

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type InfringementTableDataAction =
  | {
      type: InfringementTableDataActionType.UPDATE_FILTER;
      payload: {
        filter: keyof InfringementSummaryFilter | keyof InfringementCandidateSummaryFilter;
        value: string | string[];
      };
    }
  | {
      type: InfringementTableDataActionType.UPDATE_BOOLEAN_FILTER;
      payload: {
        filter: keyof InfringementSummaryFilter | keyof InfringementCandidateSummaryFilter;
        value: boolean | null;
      };
    }
  | {
      type: InfringementTableDataActionType.UPDATE_TAG_FILTER;
      payload: {
        filter: keyof InfringementSummaryFilter | keyof InfringementCandidateSummaryFilter;
        resetFilter?: keyof InfringementSummaryFilter | keyof InfringementCandidateSummaryFilter;
        value: string | string[];
      };
    }
  | {
      type: InfringementTableDataActionType.UPDATE_TIME_RANGE_FILTER;
      payload: { start: number; end: number };
    }
  | {
      type: InfringementTableDataActionType.CLEAR_FILTER;
      payload: {
        filter: (keyof InfringementSummaryFilter | keyof InfringementCandidateSummaryFilter)[];
      };
    }
  | {
      type: InfringementTableDataActionType.CLEAR_FILTERS;
    }
  | {
      type: InfringementTableDataActionType.TOGGLE_CANDIDATES;
      payload: boolean;
    }
  | {
      type: InfringementTableDataActionType.SORT_TABLE;
      payload: string;
    };

export interface InfringementTableDataState {
  variables: Omit<
    GetInfringementsQueryVariables & GetInfringementCandidatesQueryVariables,
    'startTime' | 'endTime'
  >;
  hasCandidatesEnabled: boolean;
  hasCorrelated: boolean;
  loading: boolean;
  error: Error | undefined;
}

export interface CorrelatedLocationState {
  fromCorrelated?: boolean;
  ids?: number[]; // or number[] depending on your ID type
}
